/* eslint-disable no-unused-vars */
import { createContext, useContext, ReactNode } from 'react';
import { AnyAction, Dispatch } from 'redux';
import { PDFDocument } from 'pdf-lib';
import Teachr from '../Objects/models/Teachr';

interface ProcurationContextType {
  // Navigation
  prevStep: () => void;
  nextStep: (step: number) => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  currentStep: number;

  // Données
  teachr: Teachr;
  pdfDoc: PDFDocument | undefined;
  generalProcuration: any;

  // Actions
  triggerPdfUpdate: () => void;
  setSignature: (signUrl: string) => Promise<void>
  setSignatureText: (signText: string) => Promise<void>
  dispatch: Dispatch<AnyAction>
  setProofIsAe: () => Promise<void>
  //ae+sap=1 & sap=2
  typeOfProcuration: number
  file: any
  loading?: boolean
}

const ProcurationContext = createContext<ProcurationContextType | null>(null);

/**
 * Hook personnalisé pour utiliser le context de procuration
 * @throws Error si utilisé en dehors du ProcurationProvider
 */
export const useProcurationContext = () => {
  const context = useContext(ProcurationContext);
  if (!context) {
    throw new Error('useProcurationContext doit être utilisé à l\'intérieur d\'un ProcurationProvider');
  }
  return context;
};

interface ProcurationProviderProps {
  children: ReactNode;
  value: ProcurationContextType;
}

/**
 * Provider pour le context de procuration
 * Encapsule les composants qui ont besoin d'accéder aux données de procuration
 */
export const ProcurationProvider = ({ children, value }: ProcurationProviderProps) => {
  return (
    <ProcurationContext.Provider value={value}>
      {children}
    </ProcurationContext.Provider>
  );
};

export type { ProcurationContextType };
